import { AtlasApiClient } from '@ag1/atlas-api/client';
import {
  PostV53WrittenReviewBody,
  PostV53WrittenReviewResponse,
  V53WrittenReview
} from '@portal/types/review';
import { useMutation } from '@tanstack/react-query';

interface MutationProps {
  postBody: PostV53WrittenReviewBody;
  onComplete?: (review: V53WrittenReview) => void;
  onFail?: (error?: Error) => void;
}

const DEFAULT_PLACEHOLDER_PRODUCT_DATA = {
  product_description: '',
  product_url: 'https://drinkag1.com'
};

export function useMutationPostV53WrittenReview() {
  return useMutation({
    mutationFn: ({ postBody }: MutationProps) =>
      AtlasApiClient.createReview({ ...DEFAULT_PLACEHOLDER_PRODUCT_DATA, ...postBody }),
    onSuccess: async (
      { success, review }: PostV53WrittenReviewResponse,
      { onComplete, onFail }: MutationProps
    ) => {
      if (success) {
        onComplete?.(review);
      } else {
        onFail?.();
      }
    },
    onError: (error: Error, { onFail }: MutationProps) => {
      onFail?.(error);
    }
  });
}
